import { Loading } from '@/components/loading';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Redirect } from 'expo-router';
import { useEffect, useState } from 'react';

export default function MaybeOnboard() {
  const [onboarded, setOnboarded] = useState<boolean | null>(null);

  useEffect(() => {
    const loadOnboarded = async () => {
      setOnboarded(
        typeof (await AsyncStorage.getItem('onboarded')) === 'string'
      );
    };

    loadOnboarded();
  }, []);

  if (onboarded === null) {
    return <Loading />;
  }

  if (onboarded) {
    return <Redirect href="/auth/login" />;
  }
  return <Redirect href="/auth/onboard" />;
}
